/* unplugin-vue-components disabled */import script from "./Step1.vue?vue&type=script&setup=true&lang=ts"
export * from "./Step1.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__